<template>
  <div id="drawer-job-details" class="drawer drawer-right drawer-map-right dw-xs-10 fold" aria-labelledby="drawer-job-details" aria-expanded="true" style="">
    <div class="drawer-contents" v-if="value">
      <div class="drawer-heading">
        <h3 class="drawer-title">
          <i class="fa fa-info-circle"></i> Job Details
          <a href="#" class="btn btn-primary pull-right" @click="handleClose"><i class="fa fa-times"></i></a>
        </h3>
      </div><!-- /.drawer-heading -->
      <div class="drawer-body">

        <div class="job-details">
          <h4 v-if="job && job.id">{{ job.user.profile.company_name }}</h4>
          <p>{{ jobDecorated.number }} - {{ jobDecorated.quantity }} {{ jobDecorated.commodity ? jobDecorated.commodity.name : '&ndash;' }}</p>
          <router-link :to="{ name: 'jobs.show', params: { id: value.id }}"><i class="fa fa-external-link"></i></router-link>
        </div>

        <span class="job-status text-primary">{{ jobDecorated.status_text }}</span>

        <job-location :location="jobDecorated.location_from" title="From"></job-location>

        <job-location :location="jobDecorated.location_to" title="To"></job-location>

        <h3 class="m-t-lg">Progress</h3>

        <div class="job-overview-details">
          <div class="progress">
            <div
              :style="{ width: `${progressAssignedPercentage}%` }"
              aria-valuemax="100"
              aria-valuemin="0"
              :aria-valuenow="progressAssignedPercentage"
              role="progressbar"
              class="progress-bar-assigned">
              <span class="sr-only">{{ progressAssignedPercentage }}% Assigned</span>
            </div>

            <div
              v-if="progressCompletedPercentage > 0"
              :style="{ width: `${progressCompletedPercentage}%` }"
              aria-valuemax="100"
              aria-valuemin="0"
              :aria-valuenow="progressCompletedPercentage"
              role="progressbar"
              class="progress-bar progress-bar-primary">
              <span class="sr-only">{{ progressCompletedPercentage }}% Complete</span>
            </div>
          </div>

          <div class="row row-progress-text">
            <div class="col-xs-4">
              {{ tonnageCompleted }}
            </div>
            <div class="col-xs-4 text-center">
              of
            </div>
            <div class="col-xs-4 text-right">
              {{ jobDecorated.quantity }}
            </div>
          </div>

          <p class="running-total">
            <strong>running total</strong> {{ jobRunningTotal }}
          </p>
        </div>

        <h3 class="m-t-lg">Loads</h3>

        <ul class="list-detail">
          <job-load :load="load" :key="index" v-for="(load, index) in loadsOrderedByLoadingDate"></job-load>
        </ul>

      </div><!-- /.drawer-body -->
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { RESET_JOB } from 'vx/mutations'
import { jobProgressHelpers, jobHelpers } from 'mixins/jobs'
import JobLocation from './JobLocation'
import JobLoad from './JobLoad'
import moment from 'moment'
import { orderBy } from 'lodash'

export default {
  mixins: [jobProgressHelpers, jobHelpers],

  components: {
    JobLocation,
    JobLoad
  },

  props: [
    'value'
  ],

  watch: {
    value (value) {
      if (value === null) {
        $(this.$el).drawer('hide')
      } else {
        this.loadJob()
        $(this.$el).drawer('show')
      }
    }
  },

  computed: {
    ...mapGetters('job', ['jobDecorated']),
    ...mapGetters('job/load', ['load']),

    loadsOrderedByLoadingDate () {
      const orderByLoadingDate = load => {
        return moment(load.loading_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      }

      return orderBy(this.loads, [orderByLoadingDate, 'id'], ['asc', 'asc'])
    }
  },

  methods: {
    ...mapActions('job', ['getJob']),
    ...mapActions('job/load', ['getLoads']),
    ...mapMutations('job', [RESET_JOB]),

    handleClose () {
      this.$emit('input', null)
    },

    async loadJob () {
      this[RESET_JOB]()

      await this.getJob(this.value.id)
      this.getLoads()
    }
  }
}
</script>



// WEBPACK FOOTER //
// JobDetails.vue?3713f49a